// extracted by mini-css-extract-plugin
export default {"content":"Code_content__c+8-Q","code":"Code_code__aADBc"};